import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import IntroductionIcon from "../assets/images/navicons/introduction.svg";
import OurDNAIcon from "../assets/images/navicons/our-dna.svg";
import RecruitmentProcessIcon from "../assets/images/navicons/recruitment-process.svg";
import NewExpertOrientationIcon from "../assets/images/navicons/new-expert-orientation.svg";
import TrainingIcon from "../assets/images/navicons/training.svg";
import PhilippineHolidayIcon from "../assets/images/navicons/philippine-holiday.svg";
import InformationSecurityIcon from "../assets/images/navicons/information-security.svg";
import OurTeamIcon from "../assets/images/navicons/our-team.svg";

// Menu items array
const menuItems = [
  {path: "/introduction", label: "Introduction", icon: IntroductionIcon},
  {path: "/our-team", label: "Who's Who at iCXeed", icon: OurTeamIcon},
  {path: "/our-dna", label: "Our DNA", icon: OurDNAIcon},
  {
    path: "/recruitment-process",
    label: "Recruitment Process",
    icon: RecruitmentProcessIcon,
  },
  {
    path: "/new-expert-orientation",
    label: "New Expert Orientation",
    icon: NewExpertOrientationIcon,
  },
  {path: "/training", label: "Training", icon: TrainingIcon},
  {
    path: "/information-security",
    label: "Information Security",
    icon: InformationSecurityIcon,
  },
  {
    path: "/philippine-holidays",
    label: "Philippine Holidays",
    icon: PhilippineHolidayIcon,
  },
];

const MobileMenu: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Toggle menu visibility
  const toggleMenu = () => setIsMenuOpen((prev) => !prev);

  // Get the current page's details
  const getCurrentPageDetails = () => {
    return (
      menuItems.find((item) => item.path === location.pathname) || {
        label: "Menu",
        icon: null,
      }
    );
  };

  const {label: currentLabel, icon: currentIcon} = getCurrentPageDetails();

  return (
    <div className="mobile-menu-container">
      {/* Menu Toggle Button */}
      <div className="mobile-menu-header">
        <button
          className={`mobile-menu-toggle ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}>
          <div className="flex-box-blk">
            {currentIcon && (
              <img
                src={currentIcon}
                alt={currentLabel}
                className="current-page-icon"
              />
            )}
            <p>{currentLabel}</p>
            <span className="arrow">
              <i
                className={`fa-solid fa-chevron-${
                  isMenuOpen ? "up" : "down"
                }`}></i>
            </span>
          </div>
        </button>
      </div>

      {/* Menu Items */}
      <ul className={`mobile-menu ${isMenuOpen ? "visible" : ""}`}>
        {menuItems.map((item) => (
          <li
            key={item.path}
            className={location.pathname === item.path ? "active" : ""}>
            <Link to={item.path}>
              <img src={item.icon} alt={item.label} />
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MobileMenu;
